var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Denglong'),_c('Header',{attrs:{"userInfo":_vm.userInfo}}),_c('SideNavBar'),_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"min-height":"80vh"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }